/** isCloudinaryEnabled disables cloudinary in EU deployment */
export const isCloudinaryEnabled = (): boolean => {
  return (window as any)?.figureheadConfig?.REACT_APP_CLOUDINARY_ENABLED
}
